/**
 * @author mxkallu
 * @generatedBy GitHub Copilot 0625
 * @description new code
 */

import { LOCALEMAP } from "../constants";

export const getLocale = () => {
  if (window?.getLocale) {
    const locale = window.getLocale();
    return LOCALEMAP[locale] || "en-us";
  } else return "en-us";
};
